import React, { FC } from 'react';
import cn from 'classnames';
import dayjs from '../../../../../utils/dayjs';
import 'react-responsive-modal/styles.css';
import styles from './styles/index.module.scss';


interface IModalChangeTaskHeader {
    currentTask: any,
}

const ModalChangeTaskHeader: FC<IModalChangeTaskHeader> = (
    {
        currentTask,
    }) => {
    return (
        <>
            <div className={styles['header']}>
                <div className={styles['header--container']}>
                    <div className={styles['header-task']}>
                        <p className={styles['header-task--name']}>
                            Задача: {currentTask.title}
                        </p>
                        <div className={styles['header-task--bottom']}>
                            <p className={styles['header-task--date']}>
                                дата создания: {dayjs(currentTask.created_at).format('D MMMM YYYY г. HH:mm')}
                            </p>
                            <p className={cn(
                                styles['header-task--status'],
                                {
                                    [styles[`header-task--status_${currentTask.state_status}`]]: currentTask.state_status
                                }
                            )}>{currentTask.state}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ModalChangeTaskHeader;